.page { flex: 1; overflow-y: auto; padding: 24px 28px 48px; }
.header { margin-bottom: 24px; }
.header h1 { display: flex; align-items: center; gap: 8px; margin: 0 0 4px; }
.header p { margin: 0; }

.center {
  flex: 1; align-self: stretch;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 12px;
  color: var(--text-muted);
  padding: 48px;
}
.center h2 { margin: 0; color: var(--text-primary); }
.spin { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }

.grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
}
.card {
  display: grid; grid-template-columns: 48px 1fr auto;
  align-items: center; gap: 12px;
  padding: 12px 14px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  cursor: pointer;
  transition: border-color var(--dur-fast) var(--ease), transform var(--dur-fast) var(--ease);
}
.card:hover { border-color: var(--accent); transform: translateY(-1px); }
.logo {
  width: 48px; height: 48px; border-radius: var(--r-sm);
  background: var(--bg-elevated-2);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
}
.logo img { width: 100%; height: 100%; object-fit: contain; }
.logo span { font-weight: 600; color: var(--text-muted); }
.body { min-width: 0; display: flex; flex-direction: column; }
.body strong { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.body span { font-size: var(--fs-xs); }
.remove {
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%;
  color: var(--danger);
}
.remove:hover { background: color-mix(in oklab, var(--danger) 18%, transparent); }
